export default __webpack_public_path__ + "images/userIcon1.png";